'use client';
import { RefObject, useEffect, useState } from 'react';

export function useIsVisible(ref: RefObject<HTMLElement>): boolean | undefined {
  const [isVisible, setIsVisible] = useState<boolean | undefined>(undefined);

  useEffect(() => {
    const observer = new IntersectionObserver(([entry]) =>
      setIsVisible(entry.isIntersecting),
    );

    const currentElement = ref?.current;
    if (currentElement) {
      observer.observe(currentElement);
    }

    return () => {
      if (currentElement) {
        observer.unobserve(currentElement);
      }
    };
  }, [ref]);

  return isVisible;
}
